import BlogListItem from "app/components/blogs/blog-list-item";
import Link from "app/components/i18n/Link";
import { Fragment } from "react";

const PinnedArticles = ({ posts }) => {
  return (
    <Fragment>
      {posts.map((post) => (
        <div key={post.slug} className="rounded-2xl bg-white">
          {post.frontmatter.hasDetailPage ? (
            <Link
              to={post.slug}
              className="flex flex-col px-5 py-10 delay-75 hover:opacity-50 hover:transition lg:flex-row lg:flex-wrap lg:px-10 xl:inline-grid xl:grid-flow-col xl:grid-cols-12"
            >
              <BlogListItem post={post.frontmatter} />
            </Link>
          ) : (
            <div className="flex flex-col px-5 py-10 lg:flex-row lg:flex-wrap lg:px-10 xl:inline-grid xl:grid-flow-col xl:grid-cols-12">
              <BlogListItem post={post.frontmatter} />
            </div>
          )}
        </div>
      ))}
    </Fragment>
  );
};

export default PinnedArticles;
